import { getDefaultSchoolClassesFilters } from "../../components/common/schoolYear";

export default {
  teachers: [],
  clients: [],
  students: [],
  schoolClasses: [],
  classStudents: [],
  clientLedger: [],
  lessonRegister: [],
  books: [],
  user: { id: "guest", role: "GUEST" },
  apiCallsInProgress: 0,
  settings: {
    showArchivedClients: false,
    schoolClassesFilters: getDefaultSchoolClassesFilters(),
  },
};
